import { ConfigProvider, Select, SelectProps } from 'antd';
import React from 'react';
import { BiX } from 'react-icons/bi';
import styled from 'styled-components';

import { DropDownOption } from '@/types/common';

const SelectDiv = styled.div`
  .ant-select-selector {
    border-radius: 20px;
    font-size: 14px !important;
    font-weight: 400 !important;
  }

  .ant-select-arrow {
    color: var(--main) !important;
  }
  width: '100%';
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
`;

export interface DropdownProps extends SelectProps {
  name: string;
  options: DropDownOption[];
}

const component = (props: DropdownProps) => {
  return (
    <SelectDiv>
      <ConfigProvider
        theme={{
          token: {
            colorBorder: props.value ? 'var(--main)' : '#d9d9d9',
            colorText: props.value ? 'var(--main)' : 'rgba(0, 0, 0, 0.88)',
          },
          components: {
            Select: {
              selectorBg: props.value ? 'rgba(74, 87, 195, 0.10);' : '#fff',
              optionSelectedColor: props.value ? 'var(--main)' : 'rgba(0, 0, 0, 0.88)',
            },
          },
        }}
      >
        <Select
          allowClear={{
            clearIcon: <BiX color="var(--main)" size={20} className="m-0 relative bg-[#EDEEF9] end-1 bottom-[40%]" />,
          }}
          showSearch
          optionFilterProp="children"
          value={props.value}
          defaultActiveFirstOption
          filterOption={(input, option) => {
            const label = option?.label || '';
            return label.toString().toLowerCase().includes(input.toLowerCase());
          }}
          {...props}
        >
          {props.options?.map((option) => (
            <Select.Option key={option.value} value={option.value} name={props.name}>
              {option.label}
            </Select.Option>
          ))}
        </Select>
      </ConfigProvider>
    </SelectDiv>
  );
};

export default component;
